// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/modules/Admin/pages/AccessControlMobile/QRScanner.module.css */

.QRScanner_overlay__\\+Fkrg {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
}

.QRScanner_closeBtn__hrIAd {
  position: absolute;
  top: 16px;
  right: 16px;
  background: transparent;
  border: none;
  color: #fff;
  cursor: pointer;
  font-size: 1.5rem;
}

.QRScanner_scanner__i\\+DZw {
  position: relative;
  width: 80vw;
  max-width: 300px;
  aspect-ratio: 1 / 1;       /* Гарантируем квадрат */
  background: #000;
  border-radius: 8px;
  overflow: hidden;
}

/* Внутреннее видео или canvas тоже 100% контейнера и покрывает его полностью */
.QRScanner_scanner__i\\+DZw video,
.QRScanner_scanner__i\\+DZw canvas {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;         /* Покрытие без искажения */
}
`, "",{"version":3,"sources":["webpack://./src/modules/Dispatcher/GiveAccess/components/QRScanner.module.css"],"names":[],"mappings":"AAAA,qEAAqE;;AAErE;EACE,eAAe;EACf,QAAQ;EACR,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,mBAAmB,QAAQ,wBAAwB;EACnD,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,+EAA+E;AAC/E;;EAEE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,iBAAiB,UAAU,2BAA2B;AACxD","sourcesContent":["/* src/modules/Admin/pages/AccessControlMobile/QRScanner.module.css */\r\n\r\n.overlay {\r\n  position: fixed;\r\n  inset: 0;\r\n  background: rgba(0, 0, 0, 0.7);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  z-index: 2000;\r\n}\r\n\r\n.closeBtn {\r\n  position: absolute;\r\n  top: 16px;\r\n  right: 16px;\r\n  background: transparent;\r\n  border: none;\r\n  color: #fff;\r\n  cursor: pointer;\r\n  font-size: 1.5rem;\r\n}\r\n\r\n.scanner {\r\n  position: relative;\r\n  width: 80vw;\r\n  max-width: 300px;\r\n  aspect-ratio: 1 / 1;       /* Гарантируем квадрат */\r\n  background: #000;\r\n  border-radius: 8px;\r\n  overflow: hidden;\r\n}\r\n\r\n/* Внутреннее видео или canvas тоже 100% контейнера и покрывает его полностью */\r\n.scanner video,\r\n.scanner canvas {\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  object-fit: cover;         /* Покрытие без искажения */\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"overlay": `QRScanner_overlay__+Fkrg`,
	"closeBtn": `QRScanner_closeBtn__hrIAd`,
	"scanner": `QRScanner_scanner__i+DZw`
};
export default ___CSS_LOADER_EXPORT___;
